import { createSlice } from '@reduxjs/toolkit'

const initialValue = {
    guest_user_details_popup: true,
    guest_name:'',
    event_details: {},
    logs:[],
    theme:{},
    guest_reviewer_id: null,
    is_loading: false,
    create_log_loading: false,
    timestamp: '00:00'
}


export const guestSlice = createSlice({
    name: 'guest',
    initialState: initialValue,
    reducers: {
        setGuestReviewState: (state, action) => {
            assignValueInState(action.payload, state)
        },
        resetGuestReviewState: (state) => {
            assignValueInState(initialValue, state)
        },
    },
})

const assignValueInState = (obj, state) => {
    for (const key in obj) { state[key] = obj[key] }
}

export const { setGuestReviewState, resetGuestReviewState } = guestSlice.actions
export default guestSlice.reducer